module.exports = require('./script/hb-toast.js');